import { Link } from 'react-router-dom';

/**
 * Aviso honesto para 403 ao abrir uma conversa (A-11, noturna 04/Set/2026).
 *
 * Antes, `ConversationView` tratava o 403 com `<Navigate to="/">` (Item 88) — e
 * `/` cai em `RootRedirect` → `/painel`. Medido na rede: carga direta de
 * `/atendimento/conversation/:id` devolvia `{"reason":"not-assigned"}` e o
 * operador ia parar no Painel pessoal sem saber por quê. A inbox lista o que o
 * detalhe nega; este aviso diz a razão e o caminho de volta.
 */
export function forbiddenReasonCopy(reason: string | undefined): string {
  switch (reason) {
    case 'not-assigned':
      return 'Esta conversa não está atribuída a você. Assuma-a pela caixa de entrada (aba «Aguardando atendente») ou peça ao supervisor para transferi-la.';
    case 'role-filter':
      return 'Seu papel não tem permissão para abrir esta conversa. Se precisar dela, peça ao supervisor.';
    default:
      return 'Você não tem permissão para abrir esta conversa.';
  }
}

export function ForbiddenConversationNotice({
  reason,
}: {
  reason: string | undefined;
}): JSX.Element {
  return (
    <div className="flex h-full items-center justify-center p-8">
      <div
        role="alert"
        className="max-w-md rounded-lg border border-border-subtle bg-surface-raised p-6 text-sm text-text-primary"
      >
        <h2 className="mb-2 text-base font-semibold">Sem acesso a esta conversa</h2>
        <p className="mb-4 text-text-secondary">{forbiddenReasonCopy(reason)}</p>
        <Link to="/inbox" className="font-medium underline underline-offset-2">
          Voltar à caixa de entrada
        </Link>
      </div>
    </div>
  );
}
